import React, { Component } from "react";
import {
  Button,
  Table,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
} from "reactstrap";
import ReactGA from "react-ga4";
import Header from "../HeaderComponent/Header";
import * as Constdata from "../../Constants/ApiConstants";
import * as message from "../../Constants/MessageConstant";
import SerraLoader from "../CommonComponent/Loader";
import SerraError from "../CommonComponent/Error";
import domtoimage from "dom-to-image";
import jstz from "jstz";
import {
  ColumnSeries,
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  Tooltip,
  DataLabel,
  StackingBarSeries,
  Chart,
} from "@syncfusion/ej2-react-charts";
import {
  apiFetch,
  getStringDate,
  priceDisplay,
} from "../../Constants/CommonConstant";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  addImageToPDF,
  addPdfHeader,
  compressImage,
  fetchFont,
  getElementPdfDimensions,
  loadImage,
  textCenter,
  toPng,
} from "../PdfComponent/PdfFunctions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CleanupPdf from "../PdfComponent/CleanupPdf";

class CleanupReport extends Component {
  constructor(props) {
    super(props);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.handleBacktoCleanuplist = this.handleBacktoCleanuplist.bind(this);
    this.showDetails = this.showDetails.bind(this);
    this.handleClientSidePDF = this.handleClientSidePDF.bind(this);
    this.state = {
      providerName: "",
      loggedInUser: "",
      currentDateTime: 0,
      value: undefined,
      reportDataPayload:
        this.props.location.state.data !== undefined
          ? this.props.location.state.data
          : [],
      modalLoader: false,
      errorPopup: false,
      errormessage: "",
      isErrorHeader: false,
      isFreeTrial: false,
      chartLeftImage: "",
      chartRightImage: "",
      isShowDetails: false,
      currentDs: undefined,
      resourceTypePalette: [
        "#C8FFFF",
        "#007FFF",
        "#C8C8C8",
        "#646464",
        "#3200FF",
        "#00007F",
      ],
      costPalett: ["#C4C3C3", "#2500A1"],
      legendSettings: {
        visible: true,
        position: "Bottom",
        margin: { top: 20 },
        textStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        alignment: "Center",
        toggleVisibility: false,
      },
      titleStyle: {
        color: "#393939",
        size: "16px",
        fontWeight: "bold",
        location: { x: "277", y: "26.5" },
      },
      marker: {
        dataLabel: {
          position: "Auto",
          visible: true,
          font: {
            color: "white",
            size: "16px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costPerfMarker: {
        dataLabel: {
          position: "Outer",
          visible: true,
          font: {
            color: "#393939",
            size: "16px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costxAxis: {
        valueType: "Category",
        labelStyle: {
          size: "16px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      costyAxis: {
        title: "Monthly Cost Run Rate",
        labelStyle: {
          size: "16px",
          fontWeight: "500",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
      },
      chartTitleStyle: {
        color: "#393939",
        fontWeight: "500",
        size: "17px",
        fontFamily: "Poppins, sans-serif",
      },
      progressxAxis: {
        valueType: "Category",
        labelStyle: {
          size: window.innerWidth < 767 ? "12px" : "16px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      progressyAxis: {
        labelFormat: "{value}%",
        minimum: 0,
        maximum: 100,
        interval: 25,
        labelStyle: {
          size: "12px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
      },
      isClientPdf: false,
      clientSidePdfData: [],
    };
  }

  async componentDidMount() {
    this.props.registerListners(true);
    this.getInitialData();
  }

  getInitialData = async (loader = true) => {
    await this.setState({ modalLoader: loader });
    apiFetch(Constdata.CLEANUP_REPORT_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(this.state.reportDataPayload),
    })
      .then(async (responseJson) => {
        if (responseJson.success === true && responseJson.data !== undefined) {
          await this.setState({
            clientSidePdfData: responseJson,
          });
          if (
            responseJson.data.costGraph !== undefined &&
            responseJson.data.costGraph.costChart !== undefined
          ) {
            let mxCost = Math.max.apply(
              Math,
              responseJson.data.costGraph.costChart.map(function (o) {
                return o.current_cost;
              })
            );
            let interval = Math.round(mxCost / 4);

            await this.setState({
              costyAxis: {
                interval: interval,
                maximum: mxCost + interval,
                minimum: 0,
              },
            });
          }

          //      Progress Chart
          let order = {
            percent_unanalyzed: "#6848D2",
            percent_analyzed: "#2500A1",
            percent_analysis_ineligible: "#D9CEFF",
            percent_analysis_error: "#A489FF",
            percent_optimized: "#00A17A",
            percent_custom_sized: "#26DAAE",
          };

          let label = {
            percent_unanalyzed: "Unanalyzed",
            percent_analyzed: "Analyzed",
            percent_analysis_ineligible: "Analysis Ineligible",
            percent_analysis_error: "Analysis Issue",
            percent_optimized: "Optimally Cleaned",
            percent_custom_sized: "Custom Cleaned",
          };

          let keysSorted = Object.keys(
            responseJson.data.progressGraph.progressList[0]
          ).sort((a, b) => {
            return (
              Object.keys(order).indexOf(a) - Object.keys(order).indexOf(b)
            );
          });
          let fiterData = [];
          let data = responseJson.data.progressGraph.progressList[0];

          keysSorted.map((value) => {
            if (
              parseInt(data[value]) !== 0 &&
              data[value] !== null &&
              value.startsWith("percent_")
            ) {
              let obj1 = {
                type: "StackingBar",
                dataSource: [
                  {
                    resourceName: data.resourceName,
                    [value]: data[value],
                    [`actual_${value}`]: data[`actual_${value}`],
                  },
                ],
                xName: "resourceName",
                yName: value,
                name: label[value],
                legendShape: "Rectangle",
                fill: order[value],
                marker: {
                  dataLabel: {
                    visible: true,
                    font: { size: "16px", fontFamily: " Poppins, sans-serif" },
                  },
                },
              };
              fiterData.push(obj1);
            }
          });

          Chart.Inject(
            Chart,
            StackingBarSeries,
            Category,
            Tooltip,
            Legend,
            DataLabel
          );

          let chart = new Chart({
            //Initializing Primary X Axis
            primaryXAxis: {
              valueType: "Category",
              labelStyle: {
                size: "16px",
                fontWeight: "500",
                color: "#808080",
                fontFamily: "Poppins, sans-serif",
              },
            },
            //Initializing Primary Y Axis
            primaryYAxis: {
              minimum: 0,
              maximum: 100,
              interval: 25,
              labelStyle: {
                size: "12px",
                fontWeight: "400",
                color: "#393939",
                fontFamily: "Poppins, sans-serif",
              },
              labelFormat: "{value}%",
            },
            chartArea: {
              border: {
                width: 1,
              },
            },
            series: fiterData,
            legendSettings: this.state.legendSettings,
            height: "300",
            title: "Overall Metric Data Source Progress",
            titleStyle: this.state.chartTitleStyle,
            palettes: this.state.resourceTypePalette,
            pointRender: this.progressBarPointRenderer,
            axisLabelRender: this.axisLabelRender,
            marker: this.state.marker,
          });
          chart.appendTo("#Chart");

          //     End Progress Chart

          await this.setState({
            value: responseJson.data,
            modalLoader: false,
            isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
            providerName: responseJson.orgInfo.providerName,
            currentDateTime: responseJson.orgInfo.currentDateTime,
            loggedInUser: responseJson.orgInfo.loggedInUser,
          });
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
        });
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isRefreshDSAPI !== this.props.isRefreshDSAPI) {
      if (!this.props.isRefreshDSAPI) {
        this.getInitialData(false);
      }
    }
    if (
      prevProps.isRefreshing !== this.props.isRefreshing &&
      this.props.datasourceRefreshStatus === "success"
    ) {
      this.getInitialData(false);
    }
  }

  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.processLogut();
      this.props.history.push("/");
    }
  };

  handleBacktoCleanuplist = () => {
    this.props.history.push({
      pathname: "/manageCleanup",
      state: { isGoBack: true },
    });
  };

  handleClientSidePDF = async () => {
    let isMobileDevice = window.innerWidth < 767;
    this.setState({ modalLoader: true, isClientPdf: true });
    try {
      const clickLogic = async () => {
        document.getElementById("LeftCleanupChart").click();
      };
      const timer = setInterval(clickLogic, 5000);

      const doc = new jsPDF();

      const lightFontUrl = require(`../../font/Poppins/Poppins-Light.ttf`);
      const regularFontUrl = require(`../../font/Poppins/Poppins-Regular.ttf`);
      const mediumFontUrl = require(`../../font/Poppins/Poppins-SemiBold.ttf`);
      const boldFontUrl = require(`../../font/Poppins/Poppins-Bold.ttf`);

      const [lightFont, regularFont, mediumFont, boldFont] = await Promise.all([
        fetchFont(lightFontUrl),
        fetchFont(regularFontUrl),
        fetchFont(mediumFontUrl),
        fetchFont(boldFontUrl),
      ]);

      doc.addFileToVFS("Poppins-Light.ttf", lightFont);
      doc.addFileToVFS("Poppins-Regular.ttf", regularFont);
      doc.addFileToVFS("Poppins-Medium.ttf", mediumFont);
      doc.addFileToVFS("Poppins-Bold.ttf", boldFont);

      // Add the fonts to jsdoc
      doc.addFont("Poppins-Light.ttf", "Poppins", "light");
      doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
      doc.addFont("Poppins-Medium.ttf", "Poppins", "medium");
      doc.addFont("Poppins-Bold.ttf", "Poppins", "bold");

      const imageUrl =
        window.location.origin + "" + this.props.companyDetails.LOGO;
      const imageLogo = await loadImage(imageUrl);

      const aspectRatioLogo = imageLogo.naturalWidth / imageLogo.naturalHeight;
      let logoWidth = 16;
      let logoHeight = logoWidth / aspectRatioLogo;
      const pageWidth1 = doc.internal.pageSize.getWidth();
      const xCoordinate1 = (pageWidth1 - logoWidth) / 2;

      let pgTtl =
        "Cost-Progress Report for " + this.state.providerName + " Cleanup";

      // Add the image Logo to the PDF
      doc.addImage(imageLogo, "PNG", xCoordinate1, 1, logoWidth, logoHeight);
      await addPdfHeader(
        doc,
        this.props.companyDetails.CompanyName +
          " " +
          this.props.companyDetails.ServiceName,
        pgTtl,
        getStringDate(new Date())
      );

      doc.setTextColor(57, 57, 57);
      doc.setFontSize(12);
      doc.setFont("Poppins", "medium");

      const chartStr = "Cleanup Monthly Cost Run-Rate Saving";
      const xCoordinateChartStr = await textCenter(
        doc,
        doc.getTextWidth(chartStr)
      );
      doc.text(chartStr, xCoordinateChartStr, 50);

      let costCleanupChartDims = "";
      if (isMobileDevice) {
        costCleanupChartDims = getElementPdfDimensions("costCleanupChart");
      }

      const chartLeftImage1 = await toPng("costCleanupChart");
      const chartLeftImage = await compressImage(chartLeftImage1);

      const pageTotalWidth = doc.internal.pageSize.getWidth();
      let parkingCostLeftPosition = -9;
      if (costCleanupChartDims) {
        parkingCostLeftPosition =
          pageTotalWidth / 2 - (costCleanupChartDims.width * 1) / 2;
      }

      await addImageToPDF(
        doc,
        chartLeftImage,
        parkingCostLeftPosition,
        55,
        costCleanupChartDims ? costCleanupChartDims.width * 1 : "",
        costCleanupChartDims ? costCleanupChartDims.height * 0.8 : "",
        "",
        "",
        true
      );

      // await addImageToPDF(doc, chartLeftImage, -9, 55, "", "", "", "", true);

      const progressStr = "Overall Metric Data Source Progress";
      const xCoordinateProgressStr = await textCenter(
        doc,
        doc.getTextWidth(progressStr)
      );
      doc.text(
        progressStr,
        xCoordinateProgressStr,
        costCleanupChartDims ? 180 : 140
      );

      let progressChartDims = "";
      if (isMobileDevice) {
        progressChartDims = getElementPdfDimensions("progressCleanupChart");
      }

      const chartRightImage1 = await toPng("progressCleanupChart");
      const chartRightImage = await compressImage(chartRightImage1);

      let progressChartLeftPosition = -9;
      if (progressChartDims) {
        progressChartLeftPosition =
          pageTotalWidth / 2 - (progressChartDims.width * 1) / 2;
      }

      await addImageToPDF(
        doc,
        chartRightImage,
        progressChartLeftPosition,
        costCleanupChartDims ? 185 : 145,
        progressChartDims ? progressChartDims.width * 1.1 : "",
        progressChartDims ? progressChartDims.height * 0.8 : "",
        "",
        "",
        true
      );

      // await addImageToPDF(doc, chartRightImage, -9, 145, "", "", "", "", true);

      // this.state.value.configResultList

      // for table

      doc.addPage();

      doc.addImage(imageLogo, "PNG", xCoordinate1, 1, logoWidth, logoHeight);
      await addPdfHeader(
        doc,
        this.props.companyDetails.CompanyName +
          " " +
          this.props.companyDetails.ServiceName,
        pgTtl,
        getStringDate(new Date())
      );

      const str = "Cleanup Details";

      doc.setFont("Poppins", "normal");
      doc.setTextColor(57, 57, 57);

      doc.setFontSize(12);
      const xCoordinateStr = await textCenter(doc, doc.getTextWidth(str));
      doc.setFont("Poppins", "medium");
      doc.text(str, xCoordinateStr, 45);

      doc.autoTable({
        html: "#tableSizing",
        theme: "grid",
        margin: { top: 58, left: 4 },
        tableWidth: 202, // Fixed width
        styles: {
          font: "Poppins",
          fontSize: 8,
          cellPadding: 1,
          minCellHeight: 10,
          valign: "middle",
          halign: "center",
        },
        headStyles: {
          fillColor: [216, 216, 216], // Black background for headers
          textColor: [57, 57, 57],
          halign: "center",
          valign: "middle",
          fontSize: 9,
          fontStyle: "medium",
          lineWidth: 0.1, // Border width for header cells
        },
        bodyStyles: {
          fontStyle: "normal",
          textColor: [57, 57, 57],
          valign: "middle",
          halign: "center",
          fontSize: 8,
        },
        columnStyles: {
          0: { fontStyle: "medium", cellWidth: 26, cellPadding: 2 }, // Set width for the first column
          1: { cellPadding: 2 }, // Set width for the second column
          2: { cellPadding: 2 }, // Set width for the third column
          3: { cellPadding: 2 },
          4: { cellPadding: 2 },
          5: { cellWidth: 24, cellPadding: 2 },
          6: { cellPadding: 2 },
        },
        didParseCell: (data) => {
          if (
            (data.section === "body" &&
              data.row.raw[2] &&
              data.column.index === 2) ||
            (data.row.raw[3] && data.column.index === 3)
          ) {
            data.cell.text = data.cell.text + "/month";
          }
        },
        didDrawPage: (data) => {
          if (data.pageCount > 0) {
            data.settings.margin.top = 15; // Reset startY to 15 for new pages
          }
        },
        showHead: "firstPage",
        head: false,
      });

      // for table

      const data = this.state.value.configResultList.reduce(
        (acc, list) => {
          const name = list.metricDataSourceName;
          acc.names.push(name);

          const rows =
            list?.orphanList
              ?.sort((a, b) => parseFloat(b.price) - parseFloat(a.price))
              .map((rs) => [
                rs.resourceName,
                rs.resourceType,
                rs.region,
                `${priceDisplay(rs.price)}/month`,
              ]) || [];

          acc.rows.push(...rows); // Merge rows into the accumulator
          return acc;
        },
        { names: [], rows: [] } // Initial accumulator
      );

      if (data.rows && data.rows.length > 0) {
        doc.addPage();

        doc.addImage(imageLogo, "PNG", xCoordinate1, 1, logoWidth, logoHeight);
        await addPdfHeader(
          doc,
          this.props.companyDetails.CompanyName +
            " " +
            this.props.companyDetails.ServiceName,
          pgTtl,
          getStringDate(new Date())
        );

        const headers = [["Resource Name", "Resource Type", "Region", "Price"]];

        const resourcesStr = `${data.names.join(
          ", "
        )} list of deletable resources`;
        doc.setFontSize(12);
        const xCoordinateStr2 = await textCenter(
          doc,
          doc.getTextWidth(resourcesStr)
        );
        doc.setTextColor(57, 57, 57);
        doc.setFont("Poppins", "medium");
        doc.text(resourcesStr, xCoordinateStr2, 45);

        // Use autoTable to create the table
        doc.autoTable({
          theme: "grid",
          head: headers,
          body: data.rows,
          margin: { top: 58, left: 4 },
          tableWidth: 202, // Fixed width
          styles: {
            font: "Poppins",
            fontSize: 8,
            cellPadding: 1,
            minCellHeight: 10,
            valign: "middle",
            halign: "center",
          },
          headStyles: {
            fillColor: [216, 216, 216], // Black background for headers
            textColor: [57, 57, 57],
            halign: "center",
            valign: "middle",
            fontSize: 9,
            fontStyle: "medium",
            lineWidth: 0.1, // Border width for header cells
          },
          bodyStyles: {
            fontStyle: "normal",
            textColor: [57, 57, 57],
            valign: "middle",
            halign: "center",
            fontSize: 8,
          },
          didDrawPage: (data) => {
            // Reset top margin after the first page
            if (data.pageNumber > 0) {
              data.settings.margin.top = 15;
            }
          },
        });
      }

      doc.save("Console_Cleanup.pdf");
      clearInterval(timer);
      this.setState({ modalLoader: false, isClientPdf: false });
    } catch (error) {
      console.error("Error fetching PDF:", error);
      // clearInterval(timer);
      this.setState({
        isClientPdf: false,
        modalLoader: false,
        errorPopup: true,
        errormessage: message.CacheErrorTextPdf,
        isErrorHeader: false,
        isRedirect: false,
        isPdfClick: false,
      });
    }
  };
  showDetails = async (ds) => {
    console.log(ds);
    await this.setState({
      currentDs: ds,
    });
    await this.setState((prevState) => ({
      isShowDetails: !prevState.isShowDetails,
    }));
  };

  axisLabelRender = (args) => {
    if (!isNaN(args.value) && !isNaN(args.axis.endLabel)) {
      args.text = "";
    }
  };

  axisPointRender = (args) => {
    //        if (args.point.y == 0) {
    //            args.cancel = true;
    //        } else {
    args.point.y = parseFloat(args.point.y).toFixed(2);
    args.point.text = priceDisplay(
      args.point.y,
      this.state.value?.userCurrency
    );
    //}
  };

  progressBarPointRenderer = (args) => {
    console.log(args);
    if (args.point.y == 0) {
      args.cancel = true;
    } else {
      var text = "actual_" + args.series.properties.yName;
      if (
        args.series.properties.dataSource[0][text] !== undefined &&
        args.series.properties.dataSource[0][text] !== null
      ) {
        args.point.yValue = args.series.properties.dataSource[0][text];
      }
    }
  };

  render() {
    let pgTtl = "Cost-Progress Report for Cleanup";
    return (
      <div>
        <Header
          processLogout={this.props.processLogut}
          registerListners={this.props.registerListners}
          providerName={this.state.providerName}
          resourceType="Data Sources"
          datetime={this.state.currentDateTime}
          loggedInUser={this.state.loggedInUser}
        ></Header>

        <div
          className="container-verf container-verf-padding"
          role="main"
          id="fillme"
          style={{ marginTop: "50px" }}
        >
          <div className="container1 boxShadow">
            <Row className="pageBgHeader">
              <Col
                sm="12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  id="spaceFiller"
                  className="d-none d-md-block"
                  style={{ width: "72px" }}
                ></div>
                <div
                  style={{
                    // width: "80%",
                    textAlign: "center",
                    color: "#ffffff",
                    fontSize: "18px",
                    fontWeight: "500",
                  }}
                >
                  {pgTtl}
                </div>
                <div
                  style={{
                    // width: "10%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <div style={{ display: "inline-flex" }}>
                    <div
                      outline
                      onClick={this.handleClientSidePDF}
                      style={{ margin: "auto", cursor: "pointer" }}
                    >
                      <img
                        src={require("../../images/PDF_Icon1.svg")}
                        title="Save as PDF Report"
                      />
                    </div>
                    <div
                      outline
                      onClick={this.handleBacktoCleanuplist}
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                    >
                      <img
                        style={{ margin: "5px" }}
                        src={require("../../images/Close_Icon1.svg")}
                        title="Close and go back to Manage Cleanup"
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div
              id="list_account"
              style={{ width: "100%", justifyContent: "space-between" }}
            >
              <div
                className="reportChart"
                style={{ padding: "0px", width: "100%", paddingBottom: "40px" }}
              >
                <div id="LeftChart">
                  <Row
                    id="costChart"
                    style={{ paddingTop: "20px", justifyContent: "center" }}
                  >
                    <Col sm="10">
                      <ChartComponent
                        id="cchart"
                        axisLabelRender={this.axisLabelRender}
                        pointRender={this.axisPointRender}
                        primaryXAxis={this.state.costxAxis}
                        primaryYAxis={this.state.costyAxis}
                        title={"Cleanup Monthly Cost Run-Rate Saving"}
                        titleStyle={this.state.chartTitleStyle}
                        palettes={this.state.costPalett}
                        legendSettings={this.state.legendSettings}
                      >
                        <Inject
                          services={[ColumnSeries, Legend, DataLabel, Category]}
                        />
                        <SeriesCollectionDirective>
                          <SeriesDirective
                            dataSource={
                              this.state.value !== undefined
                                ? this.state.value.costGraph.costChart
                                : []
                            }
                            xName="type"
                            yName="current_cost"
                            name="Current Cost"
                            type="Column"
                            columnWidth="0.9"
                            marker={this.state.costPerfMarker}
                          ></SeriesDirective>
                          <SeriesDirective
                            dataSource={
                              this.state.value !== undefined
                                ? this.state.value.costGraph.costChart
                                : []
                            }
                            xName="type"
                            yName="reduced_cost"
                            name="Post-Cleanup Cost"
                            type="Column"
                            columnWidth="0.9"
                            marker={this.state.costPerfMarker}
                          ></SeriesDirective>
                        </SeriesCollectionDirective>
                      </ChartComponent>
                    </Col>
                  </Row>
                  <Row
                    id="progressChart"
                    style={{ paddingTop: "20px", justifyContent: "center" }}
                  >
                    <Col sm="9">
                      <div id="Chart"></div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            <div style={{ padding: "20px 5px 20px 5px" }}>
              <div
                className="tableBgHeader"
                style={{
                  textAlign: "center",
                  color: "#ffffff",
                  fontSize: "18px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                }}
              >
                <b>Cleanup Details</b>
              </div>
              <div className="tableWrapper">
                <Table
                  id="tableSizing"
                  className="table-responsive stickyTable"
                  style={{ fontSize: "14px" }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: "110px" }}>Metrics Data Source</th>
                      <th style={{ padding: "0px" }}>Benefits</th>
                      <th style={{ padding: "0px" }}>Current Cost</th>
                      <th style={{ padding: "0px" }}>Post-Cleanup Cost</th>
                      <th>Status</th>
                      <th style={{ width: "80px" }}>When</th>
                      <th style={{ width: "90px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.value !== undefined
                      ? this.state.value.configResultList.map((ds, i) => {
                          return (
                            <tr
                              style={{
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              <td className="textfieldCentered">
                                <b>{ds.metricDataSourceName}</b>
                              </td>
                              <td className="textfieldCentered">
                                {ds.orphanList.length > 0 ? (
                                  <span
                                    className="benefitsTblCol"
                                    onClick={() => this.showDetails(ds)}
                                  >
                                    {ds.cleanupSummary}
                                  </span>
                                ) : (
                                  ds.cleanupSummary
                                )}{" "}
                              </td>
                              <td className="textfieldCentered">
                                {priceDisplay(
                                  ds.current_cost,
                                  this.state.value?.userCurrency
                                )}
                              </td>
                              <td className="textfieldCentered">
                                {priceDisplay(
                                  ds.reduced_cost,
                                  this.state.value?.userCurrency
                                )}
                              </td>
                              <td className="textfieldCentered">
                                {ds.cleanup_status}
                              </td>
                              <td className="textfieldCentered">
                                {getStringDate(ds.cleanupDateTime)}
                              </td>
                              <td className="textfieldCentered">
                                {ds.orphanList.length > 0 ? (
                                  <span
                                    className="benefitsTblCol"
                                    onClick={() => this.showDetails(ds)}
                                  >
                                    View Details
                                  </span>
                                ) : (
                                  "--"
                                )}
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </Table>
              </div>
            </div>
            <Modal
              isOpen={this.state.isShowDetails}
              toggle={this.showDetails}
              size="lg"
              backdrop={"static"}
            >
              <ModalHeader
                id="modalheader_list"
                cssModule={{ "modal-title": "modalHeader" }}
                toggle={this.showDetails}
              >
                <div
                  className="modalCompanyName"
                  dangerouslySetInnerHTML={{
                    __html: message.SerraLabsModalHeader,
                  }}
                />{" "}
                <div className="modalTitle">List of Cleanable Resources</div>
              </ModalHeader>
              <ModalBody>
                <div style={{ height: "400px", overflow: "scroll" }}>
                  <Table
                    id="tableSizing"
                    bordered={false}
                    style={{ fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{ backgroundColor: "#F6F6F6", width: "110px" }}
                        >
                          Resource Name
                        </th>
                        <th
                          style={{
                            border: "unset",
                            backgroundColor: "#F6F6F6",
                            padding: "0px",
                          }}
                        >
                          Resource Type
                        </th>
                        <th
                          style={{
                            border: "unset",
                            backgroundColor: "#F6F6F6",
                            padding: "0px",
                          }}
                        >
                          Region
                        </th>
                        <th
                          style={{
                            border: "unset",
                            backgroundColor: "#F6F6F6",
                            padding: "0px",
                          }}
                        >
                          Current Cost
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.currentDs !== undefined &&
                      this.state.currentDs.orphanList !== undefined
                        ? this.state.currentDs.orphanList
                            .sort(
                              (a, b) =>
                                parseFloat(b.price) - parseFloat(a.price)
                            )
                            .map((rs, i) => {
                              return (
                                <tr>
                                  <td className="textfieldCentered">
                                    {rs.resourceName}
                                  </td>
                                  <td className="textfieldCentered">
                                    {rs.resourceType}
                                  </td>
                                  <td className="textfieldCentered">
                                    {rs.region}
                                  </td>
                                  <td className="textfieldCentered">
                                    {priceDisplay(
                                      rs.price,
                                      this.state.value?.userCurrency
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                        : null}
                    </tbody>
                  </Table>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button className="btn btnBg" onClick={this.showDetails}>
                  Close
                </Button>
              </ModalFooter>
            </Modal>
            {this.state.errorPopup === true ? (
              <SerraError
                Errordata={this.state.errormessage}
                ErrorPopup={this.state.errorPopup}
                setErrorMethod={this.setErrorPopupState}
                isError={this.state.isErrorHeader}
              ></SerraError>
            ) : (
              ""
            )}
            {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
          </div>
        </div>
        <a id="pdfid" />

        {this.state.isClientPdf ? (
          <CleanupPdf clientSidePdfData={this.state.clientSidePdfData} />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
     // onClick datasource refresh state
     refreshStatus: state.dataSourcePayload.refreshStatus,
     isRefreshDSAPI: state.dataSourcePayload.isRefreshDSAPI,
     // 5 min datasource refresh state
     isRefreshing: state.datasource.isRefreshing,
     datasourceRefreshStatus: state.datasource.refreshStatus,
  };
};

export default connect(mapStateToProps, null)(withRouter(CleanupReport));
